import { Avatar, Grid } from "@mui/material";
import config from "configs/config";
import { useMaterialUIController } from "context";
import {
  EmailShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  EmailIcon,
  TelegramIcon,
  WhatsappIcon,
} from "react-share";
import { RWebShare } from "react-web-share";
import getText from "Translator";
export default function ShareComponent(props) {
  const [controller, dispatch] = useMaterialUIController();
  const { fileInfo } = props;
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
      }}
    >
      <Grid
        item
        style={{
          border: "2px solid #039dfc",
          borderRadius: 5,
          fontWeight: "bold",
          verticalAlign: "center",
          fontSize: 14,
          color: "#039dfc",
          textAlign: "center",
          width: "45%",
          margin: "2.5%",
          padding: "2.5%",
        }}
      >
        <WhatsappShareButton
          style={{
            height: 120,
          }}
          url={
            config.fileserver +
            "/share/" +
            fileInfo.file +
            controller.id +
            ".pdf"
          }
          title={getText("sharedfrom", "fa")}
        >
          <WhatsappIcon size={50} round={true} />
          <br />

          {getText("watsappshare", "fa")}
        </WhatsappShareButton>
      </Grid>
      <Grid
        item
        style={{
          border: "2px solid #039dfc",
          borderRadius: 5,
          fontWeight: "bold",
          verticalAlign: "center",
          fontSize: 14,
          color: "#039dfc",
          textAlign: "center",
          width: "45%",
          margin: "2.5%",
          padding: "2.5%",
        }}
      >
        <EmailShareButton
          style={{
            height: 120,
          }}
          url={
            config.fileserver +
            "/share/" +
            fileInfo.file +
            controller.id +
            ".pdf"
          }
          subject={getText("sharedfrom", "fa")}
        >
          <EmailIcon size={50} round={true} />
          <br />
          {getText("emailshare", "fa")}
        </EmailShareButton>
      </Grid>
      <Grid
        item
        style={{
          border: "2px solid #039dfc",
          borderRadius: 5,
          fontWeight: "bold",
          verticalAlign: "center",
          fontSize: 14,
          color: "#039dfc",
          textAlign: "center",
          width: "45%",
          margin: "2.5%",
          padding: "2.5%",
          cursor: "pointer",
        }}
        onClick={async () => {
          let datas = {
            capsule: fileInfo.capsule,
            forumGroup: fileInfo.capsule,
            file: fileInfo.file,
          };
          const pdfFile =
            config.fileserver +
            "/share/" +
            fileInfo.file +
            controller.id +
            ".pdf";

          window.open(pdfFile, "PRINT", "height=400,width=600");
        }}
      >
        <Avatar
          style={{
            marginRight: "auto",
            marginLeft: "auto",
            marginTop: 20,
            width: 55,
            height: 55,
            border: 2,
            BorderColor: "#039dfc",
          }}
          alt={getText("print", "fa")}
          src={require("../../../assets/images/print-icon.jpg")}
        />

        {getText("print", "fa")}
      </Grid>
      <Grid
        item
        style={{
          border: "2px solid #039dfc",
          borderRadius: 5,
          fontWeight: "bold",
          verticalAlign: "center",
          fontSize: 14,
          color: "#039dfc",
          textAlign: "center",
          width: "45%",
          margin: "2.5%",
          padding: "2.5%",
        }}
      >
        <TelegramShareButton
          style={{
            height: 120,
            width: "100%",
          }}
          url={
            config.fileserver +
            "/share/" +
            fileInfo.file +
            controller.id +
            ".pdf"
          }
          title={getText("sharedfrom", "fa")}
        >
          <TelegramIcon size={50} round={true} />
          <br />
          {getText("telegramshare", "fa")}
        </TelegramShareButton>
      </Grid>
    </div>
  );
}
